import * as React from 'react'
import { ICar, IError, IGalleryImage, IGarage } from 'shared-interfaces'

export interface IGlobalCtx {
    car: ICar | null
    setCar: React.Dispatch<React.SetStateAction<ICar | null>>
    currentImage: IGalleryImage | null
    setCurrentImage: React.Dispatch<React.SetStateAction<IGalleryImage | null>>
    garage?: IGarage | null
    setGarage?: React.Dispatch<React.SetStateAction<any | null>>
    isMobileNavigationBottomSheetOpen: boolean
    toggleMobileNavigationBottomSheet: React.Dispatch<
        React.SetStateAction<boolean>
    >
    isPlatformMenuOpen: boolean
    togglePlatformMenu: React.Dispatch<React.SetStateAction<boolean>>
    error: IError | null
    setError: React.Dispatch<React.SetStateAction<IError | null>>
}

const GlobalCtx = React.createContext<IGlobalCtx>({
    car: null,
    setCar: () => {},
    currentImage: null,
    setCurrentImage: () => {},
    isMobileNavigationBottomSheetOpen: false,
    toggleMobileNavigationBottomSheet: () => {},
    isPlatformMenuOpen: false,
    togglePlatformMenu: () => {},
    error: null,
    setError: () => {},
})

export default GlobalCtx
